import React, { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { tr } from 'mmfintech-commons'
import { PaymentMethods, useWalletPayment } from 'mmfintech-checkout-commons'

import { StyledForm } from '../WalletCheckout.styled'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { PaymentContainer } from '../../CheckoutPayment/Checkout.styled'
import { CoreButton, CoreSelect } from '../../../components'

export const WalletCheckoutAccount = ({ selectedAccount, setSelectedAccount, onSuccess, onCancel }) => {
  const { session, walletAccounts, walletAccountsError, walletPreviewError, walletPreviewFetching } = useSelector(
    ({ checkout: { session, walletAccounts, walletAccountsError, walletPreviewError, walletPreviewFetching } }) => ({
      session,
      walletAccounts,
      walletAccountsError,
      walletPreviewError,
      walletPreviewFetching
    }),
    shallowEqual
  )

  const { fetchAccounts, walletPaymentPreview } = useWalletPayment()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (selectedAccount) {
      walletPaymentPreview(selectedAccount.id, PaymentMethods.KINGDOM_WALLET, onSuccess)
    }
  }

  useEffect(() => {
    if (session) {
      const { currency } = session
      void fetchAccounts(currency)
    }
    // eslint-disable-next-line
  }, [session])

  return (
    <PaymentContainer>
      <StyledForm noValidate onSubmit={handleSubmit}>
        <div className='account-title'>{tr('CHECKOUT.WALLET_PAYMENT.TITLE', 'Pay With Wallet')}</div>

        <CoreSelect
          className='mb-3'
          options={walletAccounts}
          label={tr('CHECKOUT.WALLET_PAYMENT.ACCOUNT', 'Account')}
          onChange={(_: string, value: any) => setSelectedAccount(value)}
          value={selectedAccount}
          type='account'
        />

        <ErrorDisplay error={[walletAccountsError, walletPreviewError]} />
        <div className='wallet-checkout-accounts'>
          <CoreButton
            type='submit'
            variation='primary'
            className='mb-1'
            text={tr('CHECKOUT.BUTTONS.CONTINUE', 'Continue')}
            fullWidth
            isLoading={walletPreviewFetching}
            disabled={!selectedAccount}
            data-test='button-submit'
          />
          <CoreButton
            type='button'
            variation='tertiary'
            text={tr('CHECKOUT.BUTTONS.BACK', 'Back')}
            disabled={walletPreviewFetching}
            onClick={onCancel}
            data-test='button-back'
          />
        </div>
      </StyledForm>
    </PaymentContainer>
  )
}
